(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hoho-header"]) return;
  try {
    
document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.hh-header details[open]').forEach(el=>{el.removeAttribute('open');el.querySelector('summary').focus();});}});
document.addEventListener('click',event=>{document.querySelectorAll('.hh-header details[open]').forEach(el=>{if(!el.contains(event.target))el.removeAttribute('open');});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hoho-product"]) return;
  try {
    document.addEventListener('change',event=>{if(event.target.matches('[data-house-variant]')){const out=document.getElementById(event.target.dataset.priceTarget);if(out)out.textContent=event.target.selectedOptions[0].dataset.price;}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
